import { DEV_CONSTANTS } from './dev.constants';
import { PROD_CONSTANTS } from './prod.constants';

class Constants {
  static #isDev = process.env.REACT_APP_ENV === 'development';
  static #constants = this.#isDev ? DEV_CONSTANTS : PROD_CONSTANTS;

  static get get() {
    return this.#constants;
  }
  // Helper method to check environment
  static get isDevelopment() {
    return this.#isDev;
  }
}

export default Constants; 